import React, { useState } from 'react';
import Icon from '../../../../shared/components/Icon';
import FilterPopup from '../../../../shared/components/modals/FilterPopup';
import { useOverviewFilters } from '../../../../shared/context/OverviewFilterContext';

const WalletList = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const { appliedFilters, updateFilters, hasActiveFilters, teamId } = useOverviewFilters();

  const handleFiltersChange = (filters) => {
    updateFilters(filters);
    // Here you would refetch data based on the new filters
    console.log('WalletList: Applied filters:', filters);
  };

  const styles = {
    primaryBg: "#ffffff",
    secondaryBg: "#DDE2EE",
    textPrimary: "#0f172a",
    textSecondary: "#666666",
    accentColor: "#1d0c46",
    borderColor: "#DDE2EE"
  };

  return (
    <div className="relative h-full w-full overflow-y-auto">
      {/* Filter Button - Vertical, fixed to right edge */}
      <button
        onClick={() => setIsFilterOpen(true)}
        className="fixed z-10 transition-colors shadow-sm flex items-center justify-center gap-2 bg-white/80 backdrop-blur-sm hover:bg-white text-[#475569]"
        style={{ 
          fontFamily: 'Raleway, sans-serif',
          right: 0,
          top: '16px',
          padding: '16px 8px',
          writingMode: 'vertical-rl',
          textOrientation: 'mixed',
          transform: 'none',
          border: '1px solid #DDE2EE',
          borderRight: 'none',
          borderRadius: 0
        }}
      >
        <Icon name="filter" size={18} style={{ transform: 'rotate(90deg)' }} />
        <span className="text-sm font-medium">Filters</span>
        {hasActiveFilters() && (
          <span className="text-xs opacity-90">•</span>
        )}
      </button>

      {/* Page Content */}
      <div className="p-4 md:p-6 lg:p-8 pr-20">
        <div className="p-4 md:p-6" style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}>
          <div className="flex items-center justify-center h-64">
            <div className="text-center">
              <h3 className="text-sm font-medium mb-2" style={{ color: styles.accentColor, fontFamily: 'Raleway, sans-serif' }}>
                Wallet List Dashboard
              </h3>
              <p className="text-sm" style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}>
                Chart content will be displayed here
              </p>
              {hasActiveFilters() && (
                <div className="mt-4 text-xs" style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}>
                  Filters applied
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Filter Popup */}
      <FilterPopup 
        isOpen={isFilterOpen} 
        onClose={() => setIsFilterOpen(false)}
        onFiltersChange={handleFiltersChange}
        appliedFilters={appliedFilters}
        teamId={localStorage.getItem('selectedTeam') || 'Cryptique'}
      />
    </div>
  );
};

export default WalletList;

